module.exports = __webpack_public_path__ + "static/media/intro-photowall-24.b60f4371.jpg";